// extracted by mini-css-extract-plugin
export default {"Attentionbar":"attentionbar_Attentionbar__BJ1LR"};